import ReactPlayer from 'react-player';

import styled, {css} from 'styled-components';

import {Icon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {Text as BaseText} from 'src/components/primitives';

import {Message as BaseMessage, Time} from '../style';

const MAX_MESSAGE_WIDTH = '236px';

export const Wrapper = styled.div`
  ${mixins.stack({align: 'center'})};
  width: 100%;
  max-width: ${MAX_MESSAGE_WIDTH};
  margin: 30px 0;
`;

export const Message = styled(BaseMessage)<{hasButtons?: boolean; hasMedia?: boolean}>`
  gap: 0;
  max-width: 100%;
  margin: 0;

  ${({theme}) => css`
    padding: ${theme.spacing.s3};
    border-radius: ${theme.borderRadius.br4};
    background-color: ${theme.palette.maxChatMessage};
  `}

  ${({theme, hasButtons}) =>
    hasButtons &&
    css`
      margin-bottom: ${theme.spacing.s05};
      border-bottom-right-radius: ${theme.borderRadius.br05};
      border-bottom-left-radius: ${theme.borderRadius.br05};
    `}

  ${({hasMedia}) =>
    hasMedia &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
`;

export const Image = styled.img<{isSingle?: boolean}>`
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  padding: 1px;

  ${({theme, isSingle}) => css`
    border-radius: ${theme.borderRadius.br4} ${theme.borderRadius.br4}
      ${isSingle ? theme.borderRadius.br4 : 0} ${isSingle ? theme.borderRadius.br4 : 0};
    background-color: ${theme.palette.maxChatMessage};
  `}
`;

export const Video = styled(ReactPlayer)<{isSingle?: boolean}>`
  width: 100%;
  max-width: 100%;
  object-fit: cover;
  padding: 1px;

  ${({theme, isSingle}) => css`
    border-radius: ${theme.borderRadius.br4} ${theme.borderRadius.br4}
      ${isSingle ? theme.borderRadius.br4 : 0} ${isSingle ? theme.borderRadius.br4 : 0};
    background-color: ${theme.palette.maxChatMessage};
  `}

  video {
    ${({theme, isSingle}) => css`
      border-radius: ${theme.borderRadius.br4} ${theme.borderRadius.br4}
        ${isSingle ? theme.borderRadius.br4 : 0} ${isSingle ? theme.borderRadius.br4 : 0};
      background-color: ${theme.palette.maxChatMessage};
    `}
  }
`;

export const Media = styled.div`
  position: relative;
  width: 100%;
  min-height: 30px;
  overflow: hidden;

  ${({theme}) => css`
    border-radius: ${theme.borderRadius.br4};
    background-color: ${theme.palette.maxChatMessage};
  `}
`;

export const MediaTime = styled.div`
  ${mixins.f1};
  position: absolute;
  bottom: 6px;
  left: 6px;
  background: rgba(18 18 18 / 50%);

  ${({theme}) => css`
    padding: ${theme.spacing.s05} ${theme.spacing.s1};
    color: ${theme.palette.white};
    border-radius: ${theme.borderRadius.br2};
  `}
`;

export const ButtonTypeIcon = styled(Icon).attrs({size: '16px'})`
  position: absolute;
  top: 4px;
  right: 4px;
`;

export const Button = styled.div`
  ${mixins.truncate};
  ${mixins.f3};
  position: relative;
  width: 100%;
  min-height: 40px;
  border-radius: 6px;
  text-align: center;

  ${({theme}) => css`
    background-color: ${theme.palette.whatsAppButton};
    color: ${theme.palette.white};
    padding: ${theme.spacing.s3};
  `}
`;

export const ButtonsList = styled.div`
  ${mixins.stack({align: 'center', size: '05'})};
  width: 100%;

  ${Button}:last-child {
    ${({theme}) => css`
      border-bottom-right-radius: ${theme.borderRadius.br4};
      border-bottom-left-radius: ${theme.borderRadius.br4};
    `}
  }
`;

export const LocationWrapper = styled(Wrapper)`
  padding: 1px;

  ${({theme}) => css`
    background-color: ${theme.palette.grey100};
    border-radius: ${theme.borderRadius.br4};

    ${Button} {
      background-color: ${theme.palette.grey500};
      border-radius: ${theme.borderRadius.br3};
    }

    ${Image} {
      background-color: ${theme.palette.grey100};
    }

    ${Message} {
      background-color: ${theme.palette.grey100};
    }

    ${Time} {
      color: ${theme.palette.grey500};
    }
  `}
`;

export const AttachmentLabel = styled(BaseText)`
  ${mixins.truncate};
  max-width: 150px;
  line-height: 14px;
`;
